export enum FetchStatus {
  unloaded = 'unloaded',
  fetching = 'fetching',
  success = 'success',
  error = 'error',
}

export type FetchResult<T> = {
  status: FetchStatus
  lastFetch: string | null
  data?: T
  error?: string
}
